module.exports = __webpack_public_path__ + "static/coding_info_nontext_1_do-8d621161a401e8532746078ccf4e331f.png";